import api from './api'

export const authService = {
  // Register a new user
  async register(name, email, password) {
    const response = await api.post('/auth/register', {
      name,
      email,
      password
    })
    return response
  },

  // Login user
  async login(email, password) {
    const response = await api.post('/auth/login', {
      email,
      password
    })
    return response
  },

  // Logout user
  async logout() {
    const response = await api.post('/auth/logout')
    return response
  },

  // Get current user
  async getCurrentUser() {
    const response = await api.get('/auth/me')
    return response.data
  },

  // Update user profile
  async updateProfile(profileData) {
    const response = await api.put('/auth/profile', profileData)
    return response.data
  }
}
